import { configure, createRequestToken } from "@castleio/castle-js";

import { rollbar, RollbarLogArgument } from "@utils/rollbar";

type CastleInstance = unknown;

export type CastleAdapter = {
  initialize: () => Promise<CastleInstance | null>;
  createRequestToken: () => Promise<string | null>;
};

let castleInstance: CastleInstance | null = null;

export const createCastleAdapter = (): CastleAdapter => {
  const initialize = (): Promise<CastleInstance | null> => {
    try {
      const publishableKey = process.env.GATSBY_CASTLE_PUBLISHABLE_KEY;

      if (!publishableKey) {
        rollbar.warn("Castle publishable key is not set");
      }

      castleInstance = configure({ pk: publishableKey });

      return Promise.resolve(castleInstance);
    } catch (error) {
      rollbar.error("Failed to initialize Castle", error as RollbarLogArgument);

      return Promise.resolve(null);
    }
  };

  const generateRequestToken = async (): Promise<string | null> => {
    try {
      const token = await createRequestToken();

      return token;
    } catch (error) {
      rollbar.error("Failed to generate Castle request token", error as RollbarLogArgument);

      return null;
    }
  };

  return {
    initialize,
    createRequestToken: generateRequestToken,
  };
};
